import type { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'

import { DefaultErrorComponent } from 'components/DefaultErrorComponent'
import { Loading } from 'components/Loading'

import type { IAuthContext } from 'hooks/useUserContext'

import NotFound from 'pages/NotFound'

import { routeTree } from './routeTree.gen'

export interface RouterContext {
  auth: IAuthContext
  queryClient: QueryClient
}

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
    queryClient: undefined!,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultPendingComponent: Loading,
  defaultPendingMs: 200,
  defaultPendingMinMs: 300,
  defaultErrorComponent: DefaultErrorComponent,
  defaultNotFoundComponent: NotFound,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

declare module '@tanstack/history' {
  interface HistoryState {
    from?: { pathname: string; search?: Record<string, unknown>; hash?: string }
    reason?: string
    username?: string
  }
}
